var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannelBranch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B1BECF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.433 3.25c1.4 0 2.547 1.092 2.633 2.472l.005.167v3.027h4.04c1.401 0 2.548 1.093 2.634 2.473l.005.167V21c0 .38-.282.693-.648.743L21 21.75H4c-.38 0-.693-.282-.743-.648L3.25 21V5.889c0-1.401 1.092-2.548 2.472-2.634l.167-.005h6.544zm6.678 7.167l-3.973-.001v9.833l5.111.001.001-8.694c0-.546-.383-1.001-.895-1.113l-.12-.02-.124-.006zM12.433 4.75H5.889c-.587 0-1.07.444-1.132 1.015l-.007.124v14.36h8.821V5.889c0-.545-.383-1-.894-1.113l-.12-.02-.124-.006z",
    transform: "translate(-738 -119) translate(165 90) translate(515 10) translate(58 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelBranch);
export default __webpack_public_path__ + "static/media/channel-branch.f76ee11c8e73f89e99e09a8e890e3a4f.svg";
export { ForwardRef as ReactComponent };